import { format, isValid, parseISO } from 'date-fns';
import type { AccountingType } from 'v2-types/order';

export type EntryValues = Readonly<{
  hasAmountFaked: boolean;
  displayedAmount: number;
  sumAmountAccounted: number;
  isReceipt: boolean;
  methodLabel: string;
  entryDateLabel: string;
}>;

const getMethodLabel = (code: string) => {
  if (code.includes('proceeds')) return '-';
  if (code === 'netfunded') return 'net funded';
  return code;
};

const formatEntryDate = (entryDate: string) => {
  if (!entryDate) return '-';
  const parsedDate = parseISO(String(entryDate));
  return isValid(parsedDate) ? format(parsedDate, 'MM-dd-yyyy') : '-';
};

// Derived values shared by the desktop row and the mobile card of a ledger entry.
export const getEntryValues = (entry: AccountingType): EntryValues => {
  const { accounted_for, amount, code, entry_date, kind, posted, amount_faked } = entry;

  const sumAmountAccounted =
    code === 'net_proceeds'
      ? amount
      : accounted_for?.reduce((acc, num) => acc + num.amount, 0) ?? 0;

  const hasAmountFaked = amount_faked !== undefined && amount_faked > 0;

  const displayedAmount = hasAmountFaked && !posted ? amount_faked : amount;

  return {
    hasAmountFaked,
    displayedAmount,
    sumAmountAccounted,
    isReceipt: kind === 'receipt',
    methodLabel: getMethodLabel(code),
    entryDateLabel: formatEntryDate(entry_date),
  };
};
